export const Settings = {
    LANG: 'preferred_lang'
};